export class WorkflowDefinitionsSearchForm {
  Ids: number[];
  VersionOpts: WorkflowDefinitionsSearchFormVersionOpts;
  PageNumber: number;
  PageSize: number;
}

export enum WorkflowDefinitionsSearchFormVersionOpts {
  Latest = 'Latest',
  Published = 'Published',
  LatestOrPublished = 'LatestOrPublished',
  Draft = 'Draft',
  All = 'All',
}
